import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Configures from "../../../configures";
import {GetConfigures} from "../../../configures/serve";
const server =GetConfigures();

export default class PopupDownloadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newUpload: {
                type:"",
                name: "",
                base64string: "",
                filename: "",
            },
        }
    }



    downloadFile=(row)=>{
        var url = row.link;
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function () {
            var a = document.createElement('a'); // create html element anchor
            a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
            a.download = row.filename; // Set the file name.
            a.style.display = 'none'; // set anchor as hidden
            document.body.appendChild(a);
            a.click();
            a.remove()
        };
        xhr.open('GET', url);
        xhr.send();
    }

    openDocLink=(row)=>{
        let link =row.link;
        const dropboxId = row.dropboxref;
        const endpoint ="/files/download/"+dropboxId;
        let url = server + "" + endpoint;

        console.log("Opening link pdf link request > ", link);
        document.title = "CloudCall Document";
        window.open(url, '_blank');
    }
    getListOfFiles=()=>{
        let _this = this.props._this;
        let org = _this.state.Org;
        let module=_this.state.selectedModule;
        let files=_this.state.Files;
        let ls=[];
        for(let i in files){
            const row=files[i];
            if(row.org===org && row.module===module){
                ls.push(row);
            }
        }
        return ls;
    }

    render(){
        const title = this.props.popTitle;
        const openStatus = this.props.popStatus;
        const fnClose = this.props.popFnClose;
        const vehicle=this.props.vehicle;
        const ls=this.getListOfFiles();
        const {record}=this.props;

        if(vehicle===null){
            return null
        }

        const actions = [
            <FlatButton
                label={"Close"}
                primary={true}
                onClick={fnClose}
            />,
        ];

        const innerStyle={cursor:"pointer"};

        return (
            <MuiThemeProvider>
                <Dialog
                    title={"Record :"+record.names}
                    actions={actions}
                    modal={false}
                    open={openStatus}
                    onRequestClose={fnClose}
                    autoScrollBodyContent={true}
                >
                    <table className={"table"}>
                        <tbody>
                        {ls.map((row,index)=>{
                            return(
                                <tr key={index}>
                                    <td style={{color:"blue"}}>
                                        <il className={"fa fa-download"} style={{fontSize: 18, color: "blue"}}>&nbsp;</il>
                                        <a onClick={()=>this.downloadFile(row)} style={innerStyle}>Download</a>
                                        &nbsp;| &nbsp;
                                        <il className={"fa fa-list"} style={{fontSize: 18, color: "blue"}}>&nbsp;</il>
                                        <a onClick={()=>this.openDocLink(row)} style={innerStyle}>Open</a>
                                    </td>
                                    <td>{row.category}</td>
                                    <td>{row.orgdatetime}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>


                </Dialog>
            </MuiThemeProvider>
        )

    }
}
